/**
* @file 资源管理-司机流水
* */
<template>
  <div id="vehicleFlowing">
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :paging="false"
      :columns="columns"
      
      addText=""
      excel-type="VehicleFlowing"
      :summaryList="[
        { name: 'orderFinishNum' },
        { name: 'orderPassengerNum' },
        { name: 'orderFee', beforeUnit: '￥' },
      ]"
    >
      <template slot="customTable-top">
        <custom-radio-date
          @changeFn="changeBulletinFn"
          :radioGroup="[
            { value: 1, label: '昨日' },
            { value: 2, label: '最近7天' },
            { value: 3, label: '最近30天' },
            { value: 4, label: '最近半年' },
            { value: 5, label: '最近一年' },
            { value: 6, label: '从始至终' },
          ]"
        ></custom-radio-date>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime
        }}</template>

        <div v-else-if="item.prop === 'name'" class="avatar-name">
          <img
            class="avatar-img"
            v-if="row.headPortrait"
            :src="mixinQiniuImg(row.headPortrait)"
          />{{ row.name }}
        </div>

        <template v-else-if="item.prop === 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>

        <template v-else-if="item.prop === 'orderFee'">
          <span class="util-money" v-if="row[item.prop]">{{
            "￥" + row[item.prop]
          }}</span>
          <span v-if="!row[item.prop]">-</span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
import CustomRadioDate from "../../components/customRadioDate1";
export default {
  name: "vehicleFlowing",
  methods: {
    changeBulletinFn(val) {
      this.customOptions.params.timeType = val.timeType;
      this.customOptions.params.startTime = val.startTime;
      this.customOptions.params.endTime = val.endTime;
      this.$nextTick(() => {
        if (this.loadStatus) {
          this.loadStatus = false;
        } else {
          this.$refs.customTable.listFn();
        }
      });
    },
  },
  components: { CustomRadioDate },
  data() {
    return {
      loadStatus: true,
      // 配置项
      customOptions: {
        params: {},
        // 请求的列表url
        url: "/api/v1/manage/flowing/statistics/vehicle",
        setTime: true,
        search: [
          {
            type: "input",
            field: "licenseNo",
            name: "车辆号牌",
            value: "",
          },

          {
            type: "input",
            field: "vehicleNo",
            name: "车辆编号",
            value: "",
          },
          {
            type: "input",
            field: "companyName",
            name: "车辆所属",
            value: "",
          },
          {
            type: "select",
            field: "sort",
            name: "排序",
            value: 1,
            option: [
              { label: "完成订单-从高到低", value: 1 },
              { label: "订单流水-从高到低", value: 2 },
              { label: "载客人数-从高到低", value: 3 },
            ],
          },
        ],
      },
      columns: [
        { prop: "licenseNo", label: "车辆号牌" },
        { prop: "vehicleNo", label: "车辆编号" },
        {prop: "companyName", label: "车辆所属"},
        { prop: "orderFinishNum", label: "完成订单" },
        { prop: "orderFee", label: "订单流水" },
        { prop: "orderPassengerNum", label: "载客人数" },

      ],
    };
  },
};
</script>

<style lang="less">
#vehicleFlowing {
  .avatar-name {
    display: flex;
    align-items: center;

    .avatar-img {
      width: 32px;
      height: 32px;
      background-color: #ccc;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
</style>
